export const initialBillingView = { scopeKey: null, requestId: null, entries: [], summary: null, status: 'idle', error: null };

export default function clientBillingView(state = initialBillingView, action) {
  if (action.type === 'BILLING_VIEW_BEGIN') return { ...initialBillingView, scopeKey: action.scopeKey, requestId: action.requestId, status: 'loading' };
  if (action.scopeKey !== state.scopeKey || action.requestId !== state.requestId) return state;
  if (action.type === 'BILLING_VIEW_LOADED') return { ...state, entries: action.entries, summary: action.summary, status: 'ready' };
  if (action.type === 'BILLING_VIEW_ERROR') return { ...state, status: 'error', error: action.error };
  return state;
}
